var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.813 12.125l9.5-9.5a2.018 2.018 0 012.843 0l1.219 1.219c.094.094.188.219.25.312a1.994 1.994 0 01-.25 2.532l-9.5 9.5c-.031.03-.094.062-.125.125a3.32 3.32 0 01-1.031.562l-3.782 1.094a.638.638 0 01-.718-.188.708.708 0 01-.219-.718l1.125-3.782c.125-.437.375-.844.688-1.156zm.75 1.594l-.72 2.437 2.438-.718c.188-.063.375-.157.532-.313l7.156-7.156L12 6.03l-7.125 7.157c-.031 0-.031.03-.063.062-.125.125-.187.281-.25.469z",
    fill: "#011F31"
  })));
}

export default SvgEdit;